import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
//引入rem - 限制clientWidth上限为750px，PC端也不会超出移动端尺寸
;(function flexible (window, document) {
  var docEl = document.documentElement
  var dpr = window.devicePixelRatio || 1

  function setBodyFontSize () {
    if (document.body) {
      document.body.style.fontSize = (12 * dpr) + 'px'
    } else {
      document.addEventListener('DOMContentLoaded', setBodyFontSize)
    }
  }
  setBodyFontSize();

  // 核心：限制clientWidth上限为750，PC端rem基准不会超出移动端
  // Safari兼容：优先使用window.innerWidth获取真实视口宽度，避免docEl.clientWidth在iframe/Safari中返回错误值
  function setRemUnit () {
    var viewWidth = docEl.clientWidth || window.innerWidth
    // Safari/iframe环境下docEl.clientWidth可能不准确，取innerWidth作为校正
    var actualWidth = Math.max(viewWidth, window.innerWidth || viewWidth)
    var clientWidth = Math.min(actualWidth, 750)
    var rem = clientWidth / 10
    docEl.style.fontSize = rem + 'px'
  }

  setRemUnit()

  window.addEventListener('resize', setRemUnit)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      setRemUnit()
    }
  })

  if (dpr >= 2) {
    var fakeBody = document.createElement('body')
    var testElement = document.createElement('div')
    testElement.style.border = '.5px solid transparent'
    fakeBody.appendChild(testElement)
    docEl.appendChild(fakeBody)
    if (testElement.offsetHeight === 1) {
      docEl.classList.add('hairlines')
    }
    docEl.removeChild(fakeBody)
  }
}(window, document))
//引入组件
import 'vant/lib/index.css';
import Vant from 'vant';
// 引入公共的css
import '@/assets/css/reset.css'
//引入
import store from './store'
//引入时间插件
import dayjs from 'dayjs'
//全局注入api
import configApi from '@/api'
//全局注入公共方法
import untils from '@/until/until'

import VmFormRender from './vform/VmFormRender.umd.min.js'   //引入VFormRender组件
import './vform/VmFormRender.css'  //引入VFormRender样式
Vue.use(VmFormRender)  //全局注册VFormRender等组件
// 忽略
Vue.config.ignoredElements = ['wx-open-subscribe']
// import Vconsole from 'vconsole';
// new Vconsole()

import {
  preventReClick,
  RandomBgColor,
  dateDiff,
  asynDateDiff
} from '@/directive/directive.js'
Vue.use(Vant)
Vue.config.productionTip = false;

//使用自定义指令
Vue.use(preventReClick).use(dateDiff).use(asynDateDiff).use(RandomBgColor)
Vue.use(configApi)
Vue.prototype.dayjs = dayjs;
Vue.prototype.$untils = untils;

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }

  next()

})

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
